import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  ToastInnerContainer,
  ToastMessage,
  ToastOuterContainer,
} from '@app/components/toast/toast-components';
import Icon from '@app/components/icon';
type ToastProps = {
  message: any;
  showToast: boolean;
  onClose: (e?: any) => void;
  name?: string;
  isError?: boolean;
};

export default function Toast({
  message,
  showToast,
  onClose,
  name,
  isError,
}: ToastProps) {
  if (showToast) {
    toast(
      <ToastInnerContainer isError={isError}>
        <Icon name={isError ? 'close' : 'tick'} />
        <ToastMessage>{message}</ToastMessage>
      </ToastInnerContainer>,
      { onClose: onClose },
    );
  }
  return (
    <ToastOuterContainer>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        pauseOnFocusLoss
        pauseOnHover={false}
        className="munitech_toast"
        closeButton={false}
      />
    </ToastOuterContainer>
  );
}
